import { render } from "./401.vue?vue&type=template&id=bb5842a6&scoped=true"
import script from "./401.vue?vue&type=script&lang=js"
export * from "./401.vue?vue&type=script&lang=js"

import "./401.vue?vue&type=style&index=0&id=bb5842a6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5842a6"]])

export default __exports__